<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'edit_glass' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="cancel()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-button class="filter-btn" fill="clear" (click)="openFilterModal()">
    <ion-icon name="search-outline" slot="start"></ion-icon>
    {{ 'filter' | translate }}
    <span *ngIf="isFilterActive" class="filter-active-dot"></span>
  </ion-button>
  <app-edit-glass-list [glasses]="filteredGlasses" [selectedGlass]="selectedGlass" (glassSelected)="selectGlass($event)"
    (glassInfoClicked)="showGlassInfo($event)" [showGlassName]="true">
  </app-edit-glass-list>
</ion-content>

<ion-footer [translucent]="false" class="ion-no-border">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="validate()" expand="block">
      {{'validate' |translate}}
    </ion-button>
  </div>
</ion-footer>